module.exports = __webpack_public_path__ + "1dee00411442e30e979a4eaa00e563e1.jpg";